import { Expose, instanceToPlain, plainToInstance, Transform } from 'class-transformer'
import type { PersonSearchResource as Model } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'
import PersonDetailsResponse from '@/services/api/transformers/PersonDetailsResponse'

export type SerializedPersonSearchResource = Model

export default class PersonSearchResource implements CamelCaseKeys<SerializedPersonSearchResource> {
    id?: Model['id']

    @Expose({ name: 'person_details' })
    @Transform(({ value }) => plainToInstance(PersonDetailsResponse, value), { toClassOnly: true })
    @Transform(({ value }) => instanceToPlain(value), { toPlainOnly: true })
    personDetails?: PersonDetailsResponse

    constructor(values: PersonSearchResource) {
        Object.assign(this, values)
    }
}
